export default __webpack_public_path__ + "static/media/cloudstory1.ceeb7636.webp";